export default __webpack_public_path__ + "static/media/wallpaper.3472d670.jpg";